import { createAction } from '@reduxjs/toolkit'
import isNull from 'lodash/isNull'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { DocumentMarkupStoreState, handleBaseDocument, OverlayMarkupTools } from './insertEstimatedOptionOverlay'
import { selectMarkupState } from './markupDocument'
import { PROJECT_PAGE_TAB_VALUES } from '../../../shared/constants/project-settings-names'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import {
    Color,
    Comment,
    Flag,
    Highlight,
    Image,
    Label,
    Overlay,
    PathTool,
    RegionTool,
    Workspace,
} from '../../lib/toolBoxes/2D/tools'
import { setOverlayChunkId } from '../../slices/2D'
import { NormalizedDocumentChunk, selectNormalizedDocumentChunks } from '../../slices/documents'
import { getActiveTab } from '../../slices/navigation'

interface OverlayPayload {
    base: number | null | undefined
    opt: number | null
}

export const reoverlayAndLockChunk = createAction<OverlayPayload>('reoverlayAndLockChunk')

export function* handleReoverlayAndLockChunk(action: ReturnType<typeof reoverlayAndLockChunk>) {
    try {
        const manager: PaperManager | null = yield call(managers.get2DManager)

        if (isNull(manager)) return
        const {
            openingGroups,
            areaOpacity,
            lineOpacity,
            drawableLocations,
            flags,
            toolObjects,
        }: DocumentMarkupStoreState = yield select(selectMarkupState)
        const [
            workspaceTool,
            overlayTool,
            regionTool,
            colorTool,
            commentTool,
            highlightTool,
            imageTool,
            flagTool,
            labelTool,
            pathTool,
        ]: OverlayMarkupTools = yield call(manager.getTools, [
            Workspace.NAME,
            Overlay.NAME,
            RegionTool.NAME,
            Color.NAME,
            Comment.NAME,
            Highlight.NAME,
            Image.NAME,
            Flag.NAME,
            Label.NAME,
            PathTool.NAME,
        ])

        const activeTab: PROJECT_PAGE_TAB_VALUES = yield select(getActiveTab)

        if (activeTab !== PROJECT_PAGE_TAB_VALUES.DIGITIZER) return

        const normalizedChunks: NormalizedDocumentChunk[] = yield select(selectNormalizedDocumentChunks)

        if (action.payload.base) {
            const toolsToBorrow = {
                workspaceTool,
                imageTool,
                flagTool,
                colorTool,
                pathTool,
                labelTool,
                regionTool,
                highlightTool,
                commentTool,
            }

            yield* handleBaseDocument(overlayTool, toolsToBorrow, action.payload.base, normalizedChunks, {
                drawableLocations,
                flags,
                toolObjects,
                openingGroups,
                lineOpacity,
                areaOpacity,
                activeFloor: null,
            })
        }
        yield put(setOverlayChunkId(action.payload.opt))
    } catch (error) {
        console.error('Error messages in handleReoverlayAndLockChunk:', error)
    }
}

export function* watchForUpdateReoverlayAndLockChunk() {
    yield takeEvery(reoverlayAndLockChunk.type, handleReoverlayAndLockChunk)
}
